import React from 'react';
import {twMerge} from 'tailwind-merge';

import {CloseButton} from './components/CloseButton';

export const SettingsDrawerWrapper = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => {
  return (
    <div className="flex flex-col" data-test="workspace-settings-menu">
      <div
        className={twMerge(
          'flex items-center justify-between',
          'px-20 py-16',
          'border-b-[1px] border-solid border-moon-250'
        )}>
        <h1 className={twMerge('text-xl font-semibold leading-[32px]')}>
          {title}
        </h1>
        <CloseButton />
      </div>
      {children}
    </div>
  );
};
